"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as h } from "react/jsx-runtime";
import { useTheme as v } from "../../hooks.js";
import { useIsInverseVariant as m } from "../../theme-variant-context.js";
import { vars as e } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: r, size: a = 24 } = _param, c = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = m(), o = r !== null && r !== void 0 ? r : t ? e.colors.inverse : e.colors.neutralHigh, { skinName: n } = v();
    return n.match(/^o2-new/i) ? /* @__PURE__ */ h("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ h("path", {
            fill: o,
            d: "M19.782 2H4.223A2.226 2.226 0 0 0 2 4.223v15.554C2 21 2.995 22 4.223 22h15.554A2.226 2.226 0 0 0 22 19.777V4.219A2.22 2.22 0 0 0 19.782 2m-.74 4.996a.555.555 0 0 0 0-1.11h-.924v-.923a.55.55 0 0 0-.555-.555.55.55 0 0 0-.555.555v.924h-.924a.55.55 0 0 0-.555.555c0 .308.247.554.555.554h.924v.925c0 .308.247.554.555.554a.55.55 0 0 0 .555-.554v-.925zm-2.54 4.798c.198-.313.317-.688.317-1.095A2.017 2.017 0 0 0 14.78 8.66h-2.038a.74.74 0 0 0-.74.74v5.19c0 .408.332.74.74.74h2.408a2.017 2.017 0 0 0 2.038-2.038c0-.593-.265-1.124-.687-1.498m-3.02-1.65h1.293a.53.53 0 0 1 .555.555.53.53 0 0 1-.555.554h-1.294zm0 3.707v-1.11h1.587c.346 0 .63.252.63.556a.526.526 0 0 1-.549.554zm-2.22-1.853A3.3 3.3 0 0 1 7.93 15.33c-1.939 0-3.517-1.493-3.517-3.332a3.3 3.3 0 0 1 3.332-3.333c.522 0 1.513.085 2.243.673.317.256.37.72.113 1.043a.744.744 0 0 1-1.042.114c-.27-.218-.764-.346-1.314-.346-1.057 0-1.853.796-1.853 1.853 0 1.02.915 1.854 2.038 1.854.792 0 1.432-.446 1.707-1.11H8.3a.74.74 0 0 1 0-1.478h2.223c.408-.01.74.322.74.73m8.52 8.518H4.223a.74.74 0 0 1-.74-.74V4.22a.74.74 0 0 1 .74-.74h15.554a.74.74 0 0 1 .74.74v15.558h.004a.74.74 0 0 1-.74.74"
        })
    })) : /* @__PURE__ */ h("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ h("path", {
            fill: o,
            d: "M19.782 2H4.223A2.226 2.226 0 0 0 2 4.223v15.554C2 21 2.995 22 4.223 22h15.554A2.226 2.226 0 0 0 22 19.777V4.219A2.22 2.22 0 0 0 19.782 2m-.74 4.996a.555.555 0 0 0 0-1.11h-.924v-.923a.55.55 0 0 0-.555-.555.55.55 0 0 0-.555.555v.924h-.924a.55.55 0 0 0-.555.555c0 .308.247.554.555.554h.924v.925c0 .308.247.554.555.554a.55.55 0 0 0 .555-.554v-.925zm-2.54 4.798c.198-.313.317-.688.317-1.095A2.017 2.017 0 0 0 14.78 8.66h-2.038a.74.74 0 0 0-.74.74v5.19c0 .408.332.74.74.74h2.408a2.017 2.017 0 0 0 2.038-2.038c0-.593-.265-1.124-.687-1.498m-3.02-1.65h1.293a.53.53 0 0 1 .555.555.53.53 0 0 1-.555.554h-1.294zm0 3.707v-1.11h1.587c.346 0 .63.252.63.556a.526.526 0 0 1-.549.554zm-2.22-1.853A3.3 3.3 0 0 1 7.93 15.33c-1.939 0-3.517-1.493-3.517-3.332a3.3 3.3 0 0 1 3.332-3.333c.522 0 1.513.085 2.243.673.317.256.37.72.113 1.043a.744.744 0 0 1-1.042.114c-.27-.218-.764-.346-1.314-.346-1.057 0-1.853.796-1.853 1.853 0 1.02.915 1.854 2.038 1.854.792 0 1.432-.446 1.707-1.11H8.3a.74.74 0 0 1 0-1.478h2.223c.408-.01.74.322.74.73m8.52 8.518H4.223a.74.74 0 0 1-.74-.74V4.22a.74.74 0 0 1 .74-.74h15.554a.74.74 0 0 1 .74.74v15.558h.004a.74.74 0 0 1-.74.74"
        })
    }));
}, f = i;
export { f as default };
